import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Box, MenuItem as MuiMenuItem, Pagination, Select, Typography } from "@mui/material";
import { toast } from 'react-toastify';
import defaultImage from '../../utils/DefaultImage';
import TableLoader from '../../utils/TableLoader';

const PastOrder = ((props, ref) => {
  const { rest_slug2 } = useParams();
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const [orderData, setOrderData] = useState([]);
  const [viewOrderData, setViewOrderData] = useState({});

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedStatus, setSelectedStatus] = useState("In Attesa");
  const statuses = ["In Attesa", "Accettato"];

  const orderDatas = [
    // {
    //   "id": 1,
    //   "order_number": "#1479812667797",
    //   "no_of_wines_in_order": "2",
    //   "order_date": "27 Jan 2024",
    //   "status": 'Accepted'
    // },
    // {
    //   "id": 2,
    //   "order_number": "#3016-734428-7759",
    //   "no_of_wines_in_order": "4",
    //   "order_date": "27 Jan 2024",
    //   "status": 'Accepted'
    // },
    // {
    //   "id": 3,
    //   "order_number": "#1479812667797",
    //   "no_of_wines_in_order": "1",
    //   "order_date": "27 Jan 2024",
    //   "status": 'Rejected'
    // },
    // {
    //   "id": 4,
    //   "order_number": "#3016-734428-7759",
    //   "no_of_wines_in_order": "5",
    //   "order_date": "27 Jan 2024",
    //   "status": 'Not OK'
    // },
    // {
    //   "id": 4,
    //   "order_number": "#1479812667797",
    //   "no_of_wines_in_order": "10",
    //   "order_date": "27 Jan 2024",
    //   "status": 'Rejected'
    // }
  ]

  const getOrdersData = async () => {
    setIsLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const params = {
        pageNumber: page,
        size: rowsPerPage,
      };

      const response = await axios.get(`${apiUrl}/api/v1/restaurants/${rest_slug2}/orders`, { 
        headers,
        params 
      });

      const data = response.data;
      const ordersWithStatus = data.data.map(order => ({
        ...order,
        selectedStatus: order.status
      }));
      setSelectedStatus(ordersWithStatus)
      setOrderData(data.data);
      setTotalPages(data.total);
    } catch (error) {
      console.error('Error fetching order data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // const getViewOrdersData = async () => {
  //   setIsLoading(true);
  //   try {
  //     const OrderId = selectedOrder.id;
  //     const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;

  //     // Fetch order data
  //     const response = await axios.get(`${apiUrl}/api/v1/orders/${OrderId}/wines`, {
  //       params: {
  //         pageNumber: page,
  //         size: rowsPerPage,
  //       },
  //     });
  //     // Set order data response
  //     const data = response.data;
  //     setViewOrderData(data.wines.data);
  //     setTotalPages(data.total);
  //   } catch (error) {
  //     console.error('Error fetching or updating order data:', error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleChange = (event, value) => {
    setPage(value);
  };

  // Function to handle status selection
  const handleStatusSelect = async (status, orderId) => {
    // console.log("Selected status:", status);
    // console.log("Order ID:", orderId);

    try {
      // Update order status via API
      await axios.put(`${apiUrl}/api/v1/orders/${orderId}/status`, {
        status: status,
      });
      // Update local orderData state after successful status update
      setOrderData((prevOrderData) =>
        prevOrderData.map((order) =>
          order.id === orderId ? { ...order, status: status } : order
        )
      );
      setOpenDropdownId(null);
      toast("Status Changed Successfully");
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };

  const handleViewOrderClick = (order) => {
    setSelectedOrder(order);
    setShowOrder(true);
  };

  const toggleDropdown = (orderId) => {
    setOpenDropdownId((prevOpenDropdownId) =>
      prevOpenDropdownId === orderId ? null : orderId
    );
  };

  useImperativeHandle(ref, () => ({
    pastOrder() {
      setShowOrder(false)
    },
  }));

  useEffect(() => {
    getOrdersData();
    if (selectedOrder) {
      getViewOrdersData();
    }
  }, [page, rowsPerPage, selectedOrder]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <section className="border-t border-[#D9D9D9] mt-5 pt-5">
        {showOrder && selectedOrder ? (
          <>
            <div className='flex lg:flex-row flex-col  justify-between'>
              <div>
                <h3 className="flex sm:text-3xl text-xl font-bold mb-2 poppins-medium items-center">
                  {/* <p className='text-lg font-light poppins-medium mr-6'>0{selectedOrder.id || 'N/A'} </p>  */}
                  {selectedOrder.order_number || 'N/A'}
                </h3>
              </div>
              <p className='text-lg font-normal poppins-medium mr-4'>{selectedOrder.order_date || 'N/A'} </p>
            </div>
            <div className="dash-table-main w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
              <table className="w-full text-left wine_table">
                <thead>
                  <tr className="border-b border-[#8B2433]">
                    <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">Immagine</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nome</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Tipologia</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nazione</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Quantità</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo totale</th>
                  </tr>
                </thead>
                {isLoading ? (
                  <TableLoader />
                ) : (
                  <tbody>
                    {viewOrderData?.length ? (
                      viewOrderData?.map((orderInfo, index) => (
                        <tr key={index} className="border-b border-[#8B2433]/12">
                          <td className="pr-2 py-4">
                            <div className="thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                              <img
                                className="w-100 p-1 h-100 object-contain border border-[#68172394] rounded-lg"
                                src={orderInfo?.wine?.image && orderInfo?.wine?.image !== "" ? orderInfo?.wine?.image : defaultImage}
                                height={50}
                                width={50}
                              />
                            </div>
                          </td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine.name || 'N/A'}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine.product_type || 'N/A'}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.country || 'N/A'}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.price ? `${orderInfo?.price} €` : 'N/A'}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                            <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                              {orderInfo?.bottles_quantity || 0}
                            </span>
                          </td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                            {orderInfo?.price && orderInfo?.bottles_quantity ? `${(orderInfo?.price * orderInfo?.bottles_quantity).toFixed(2)} €` : 'N/A'}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center py-4">Nessun ordine passato trovato</td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>

            </div>
            <div className="flex sm:flex-row flex-col gap-4  text-xs items-center justify-between p-2 pt-5 pb-3">
              <Box
                display="flex"
                alignItems="center"
                sx={{ fontSize: '0.875rem', fontFamily: 'Poppins, sans-serif', padding: '5px', width: 'fit-content' }}
              >
                <Typography sx={{ color: "#717171", fontSize: '13px', marginRight: '0px', fontFamily: 'Poppins, sans-serif' }}>
                  Mostra
                </Typography>
                <Select
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(e.target.value);
                    setPage(1);
                  }}
                  sx={{
                    borderRadius: "6px",
                    borderColor: "#B8B8B8",
                    opacity: 1,
                    margin: "0 5px",
                    height: '30px',
                    fontSize: '13px',
                    fontFamily: 'Poppins, sans-serif',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#B8B8B8',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#B8B8B8',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#B8B8B8',
                    },
                  }}
                >
                  <MuiMenuItem value={10}>10</MuiMenuItem>
                  <MuiMenuItem value={25}>25</MuiMenuItem>
                  <MuiMenuItem value={50}>50</MuiMenuItem>
                  <MuiMenuItem value={100}>100</MuiMenuItem>
                </Select>

                <Typography sx={{ fontSize: '0.875rem', fontFamily: 'Poppins, sans-serif' }}>
                  di {totalPages} risultati
                </Typography>
              </Box>
              {/* <Typography>di {totalResults} risultati</Typography> */}
              <Pagination
                count={totalPages < rowsPerPage ? 1 : Math.ceil(totalPages / rowsPerPage)}
                page={page}
                onChange={handleChange}
                shape="rounded"
                size="small"
                siblingCount={0}
                boundaryCount={1}
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontSize: "12px",
                    minWidth: "30px",
                    height: "30px",
                  },
                }}
              />
            </div>
          </>
        ) : (
          <>
            <h3 className="text-3xl font-bold mb-2 poppins-medium">Ordini In Passati</h3>
            <div className="dash-table-main w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
              <table className="w-full text-left wine_table">
                <thead>
                  <tr className="border-b border-[#8B2433]">
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Sr.no</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">N.Ordine</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">N.Di Vini In Ordine</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Data Ordine</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Stato Ordine</th>
                    <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B] w-[14%]">Azione</th>
                  </tr>
                </thead>
                {isLoading ? (
                  <TableLoader />
                ) : (
                  <tbody>
                    {orderDatas?.length ? (
                      orderDatas?.map((order) => (
                        <tr key={order.id} className="border-b border-[#8B2433]/12">
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">0{order?.id}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{order?.order_number}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{order?.no_of_wines_in_order}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{order?.order_date}</td>
                          <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{order?.status}</td>
                          {/* <td className="py-4 px-0 w-[14%]">
                          <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                            <div className="border border-gray-300 rounded-3xl">
                              <div onClick={() => toggleDropdown(order.id)} className="flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10">
                                <span className="mr-2 flex items-center gap-3 poppins-medium">
                                  {order.status === "Pending" ? "In Attesa" :
                                    order.status === "Accepted" ? "Accettato" :
                                      order.status || "Select Status"}
                                </span>
                                <RiArrowDownSLine />
                              </div>
                              {openDropdownId === order.id && (
                                <div className="z-[99] max-h-60 bg-[#FFFFFF] absolute top-14 p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out">
                                  {statuses
                                    .filter((status) => status !== order.status)
                                    .map((status, index, array) => (
                                      <label
                                        key={status}
                                        className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                                        onClick={() => handleStatusSelect(status, order.id)}
                                      >
                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                          {status}
                                        </span>
                                      </label>
                                    ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </td> */}
                          <td className="py-4 px-7 text-left poppins-medium text-[#303030]">
                            <button
                            // onClick={() => { handleViewOrderClick(order) }}
                            >
                              Visualizza ordine
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center py-4">Nessun ordine passato trovato</td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
          </>
        )}
      </section>
    </>
  );
})

export default forwardRef(PastOrder);
